import { render } from "./Step4.vue?vue&type=template&id=69616287&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"

import "./Step4.vue?vue&type=style&index=0&id=69616287&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69616287"]])

export default __exports__